import { AppBar, Box, Dialog, Divider, IconButton, ListItem, MenuItem, Paper, Toolbar, Typography } from '@material-ui/core'
import React, { Component } from 'react'
import { getDataIsdeletedFalse, getSecondaryColor } from '../../Helper/CommonThings';
import CloseIcon from '@material-ui/icons/Close';
import CRMTable from '../../CRM/CRMTable';
import { withSnackbar } from 'notistack';
import MapComponent from '../../Map/MapComponent';
import Service from '../../../config/networkutils';
import Auth from '../../../utils/authenticate';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

const token = Auth.token()


class Crm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            archive: [],
            live: [],
            data: [],
            title: '',
            mapOpen: false,
            type: 0,
            gateLevelArr: [],
            subSectorArr: [],
        }
        this.getCRMDataRef = React.createRef()
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleMapClose = () => {
        this.setState({
            mapOpen: false
        })
    }

    getAllList() {
        return new Promise((resolve, reject) => {
            Service.get('/api/crm/crmlinkedcolumns_api/', {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => { 
                let resData = getDataIsdeletedFalse(res.data);
                resolve(resData)
            }).catch(error => reject(error))
        })
    }

    componentDidMount() {
        Promise.all([
            this.getAllList(),
        ]).then(res => {
            this.setState({
                gateLevelArr: res[0]['gate_stage'],
                subSectorArr: res[0]['subsector']
            })

        }).catch(err => {

        })
    }


    render() {
        return (
            <div>
                <Paper style={{ borderRadius: '0 0 10px 10px' }} >
                    <ListItem style={{ padding: "10px" }}
                        onClick={() => this.setState({ open: true, title: 'Live' })} button>
                        Live
                    </ListItem>
                    <Box>
                        <Divider variant="middle" style={{ backgroundColor: getSecondaryColor() }} />
                    </Box>
                    <ListItem style={{ padding: "10px" }}
                        onClick={() => this.setState({ open: true, title: 'Archive' })} button>
                        Archive
                    </ListItem>
                    <Box>
                        <Divider variant="middle" style={{ backgroundColor: getSecondaryColor() }} />
                    </Box>
                    <ListItem style={{ padding: "10px" }}
                        onClick={() => this.setState({ mapOpen: true, title: 'Archive' })} button>
                        Project Map
                    </ListItem>
                </Paper>
                <Dialog fullScreen open={this.state.open} onClose={this.handleClose}>
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6">
                                {this.state.title}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Box marginTop={10} margin={2}>
                        <CRMTable title={this.state.title} access={this.props.access} uiRefresh={true} />
                    </Box>
                </Dialog>
                <Dialog fullScreen open={this.state.mapOpen} onClose={this.handleMapClose}>
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Box display={'flex'} justifyContent='space-between' width={'100%'} alignItems={'center'}>
                                <Box display={'flex'} justifyContent='center' alignItems={'center'}>
                                    <IconButton edge="start" color="inherit" onClick={this.handleMapClose} aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography>Project Location for CRM</Typography>
                                </Box>
                                <Box alignItems={'center'}>
                                        <FormControl variant="outlined" size='small' color='inherit' style={{ color: 'inherit', borderColor: 'inherit' }}>
                                            <InputLabel id="demo-simple-select-outlined-label" color='inherit' style={{ color: 'inherit', borderColor: 'inherit' }}>Status</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                value={this.state.type}
                                                onChange={(e) => this.setState({ type: e.target.value }, () => {
                                                    if (this.getCRMDataRef.current) {
                                                        this.getCRMDataRef.current.handleRefresh(this.state.type)
                                                    }
                                                })}
                                                label="Status"
                                                style={{ color: 'inherit', borderColor: 'inherit', width:'100px'  , '&:before': { borderColor: 'inherit' }, '&:after': { borderColor: 'inherit' }}}
                                            >
                                                <MenuItem value={0}>Live</MenuItem>
                                                <MenuItem value={1}>Archive</MenuItem>
                                            </Select>
                                        </FormControl>
                                    {/* <ThemeProvider theme={darkTheme}>
                                        <TextField
                                            id="status"
                                            name="status"
                                            value={this.state.type}
                                            onChange={(e) => this.setState({ type: e.target.value }, () => {
                                                if (this.getCRMDataRef.current) {
                                                    this.getCRMDataRef.current.handleRefresh(this.state.type)
                                                }
                                            })}
                                            // color='inherit'
                                            variant='outlined'
                                            label={"Status"}
                                            select
                                            size='small'
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left"
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left"
                                                },
                                                getContentAnchorEl: null
                                            }}
                                        // style={{color:'inherit', borderColor: 'inherit'}}

                                        >
                                            <MenuItem value={0}>Live</MenuItem>
                                            <MenuItem value={1}>Archive</MenuItem>
                                        </TextField>
                                    </ThemeProvider> */}
                                </Box>
                            </Box>
                        </Toolbar>
                    </AppBar>
                    <Box marginTop={8} width={'100%'} height={'100%'}>
                        <MapComponent ref={this.getCRMDataRef} gateLevelArr={this.state.gateLevelArr} subSectorArr={this.state.subSectorArr} />
                    </Box>
                </Dialog>
            </div>
        )
    }
}

export default withSnackbar(Crm);
